'use strict';

var Bacon, R, gqlSvcBus, gqlSvcUrl, gqlSvcUrlVar, loadHOP, loadRDR, makePayload, query, queryDeliveryRules, queryHOP, resUtil, restaurant, restaurantBus, _restaurantHOP, restaurantId, restaurantRDR, variables;

Bacon = require('baconjs');

R = require('ramda');

resUtil = require('../utils/resources');

gqlSvcUrlVar = null;

gqlSvcBus = new Bacon.Bus();

gqlSvcUrl = gqlSvcBus.toProperty();

gqlSvcUrl.onValue(function (url) {
  // Force 1 listener
  return gqlSvcUrlVar = url;
});

query = "query Restaurant($restaurant_id: ID!) {\n  restaurant(id: $restaurant_id) {\n    id\n    name\n    permalink\n    locale\n    timezone {\n      offset\n    }\n    settings {\n      sold_out\n      disable_quantity\n      order_time_type\n      days_off\n      hide_comments\n      pause_online_ordering\n      extra_fields\n      napkins\n      catering\n      require_cross_street\n      delivery {\n        use_only_address_rules\n      }\n    }\n    services {\n      id\n      label\n      min_order\n      description\n    }\n    locations {\n      id\n      address { street, city, geo { lat, lng} }\n    }\n    menu_messages {title, description, asset_url}\n  }\n}";

queryHOP = "query RestaurantHOP($restaurant_id: ID!) {\n  restaurant(id: $restaurant_id) {\n    hours_of_operation\n    timezone {\n      offset\n    }\n  }\n}";

queryDeliveryRules = "query RestaurantRDR($restaurant_id: ID!) {\n  restaurant(id: $restaurant_id) {\n    settings {\n      delivery {\n        rules {\n          ruleType\n          address {\n            city\n            complete_address\n            country\n            lat\n            lng\n            nickname\n            precision\n            state\n            street\n            zip\n          }\n        }\n      }\n    }\n  }\n}";

restaurantBus = new Bacon.Bus();

restaurantId = restaurantBus.map(parseInt).skipDuplicates(R.equals).toProperty();

variables = restaurantId.map(parseInt).map(R.assoc('restaurant_id', R.__, {})).map(R.bind(JSON.stringify, JSON)).toProperty();

makePayload = function makePayload(url, vars, q, operation) {
  return {
    url: url,
    variables: vars,
    query: Bacon.constant(q),
    operationName: Bacon.constant(operation)
  };
};

restaurant = Bacon.combineTemplate(makePayload(gqlSvcUrl, variables, query, "Restaurant")).flatMap(resUtil.post).map(R.path(["data", "restaurant"]));

loadHOP = new Bacon.Bus();

_restaurantHOP = Bacon.combineTemplate(makePayload(gqlSvcUrl, variables, queryHOP, "RestaurantHOP")).sampledBy(loadHOP).flatMap(resUtil.post).map(R.path(["data", "restaurant"])).toProperty();

loadRDR = new Bacon.Bus();

restaurantRDR = Bacon.combineTemplate(makePayload(gqlSvcUrl, variables, queryDeliveryRules, "RestaurantRDR")).sampledBy(loadRDR).flatMap(resUtil.post).map(R.path(["data", "restaurant", "settings", "delivery", "rules"])).map(R.filter(R.propEq("ruleType", "AddressRule"))).map(R.map(R.prop('address'))).toProperty();

module.exports = {
  restaurantId: restaurantId,
  restaurant: restaurant.toProperty(),
  restaurantHOP: function restaurantHOP() {
    setTimeout(function () {
      return loadHOP.push(new Date());
    }, 0);
    return _restaurantHOP;
  },
  deliveryAddresses: function deliveryAddresses() {
    setTimeout(function () {
      return loadRDR.push(new Date());
    }, 0);
    return restaurantRDR;
  },
  loadRestaurant: function loadRestaurant(id) {
    return restaurantBus.push(id);
  },
  setURL: function setURL(url) {
    return gqlSvcBus.push(url);
  },
  url: gqlSvcUrl,
  getRestaurantsAPISvcURL: function getRestaurantsAPISvcURL() {
    return gqlSvcUrlVar;
  }
};